import React from 'react';
import { expenseAmountMagnitude } from '../utils/operationBudgetArticle';
import { formatContractSumDisplay } from '../utils/table';

interface BalanceBarChartProps {
  receipts: number;
  expenses: number;
}

const BalanceBarChart: React.FC<BalanceBarChartProps> = ({ receipts, expenses }) => {
  const receiptsVal = receipts > 0 ? receipts : 0;
  const expensesVal = expenseAmountMagnitude(expenses);
  const max = Math.max(receiptsVal, expensesVal, 1);
  const receiptsHeight = receiptsVal > 0 ? Math.max(8, Math.round((receiptsVal / max) * 32)) : 4;
  const expensesHeight = expensesVal > 0 ? Math.max(8, Math.round((expensesVal / max) * 32)) : 4;

  return (
    <div className="task-detail__balance-bars" aria-hidden>
      <div className="task-detail__balance-bars-inner">
        <div
          className="task-detail__balance-bar task-detail__balance-bar--receipts"
          style={{ height: receiptsHeight }}
          title={`Поступления: ${formatContractSumDisplay(receipts)}`}
        />
        <div
          className="task-detail__balance-bar task-detail__balance-bar--expenses"
          style={{ height: expensesHeight }}
          title={`Расходы: ${formatContractSumDisplay(expensesVal)}`}
        />
      </div>
    </div>
  );
};

export default BalanceBarChart;
